<template>
    <van-icon
        v-if="message"
        name="warning-o"
        class="c_error"
        @click="toast.fail(message)"
    />
</template>
<script>
export default {
    props: {
        message: {
            type: String,
            default: ""
        }
    }
};
</script>
